import type {
  BundleAnalysis,
  DataResponse,
  PaginatedResponse,
  Skill,
  SkillCreate,
  SkillDeleteImpact,
  SkillImportResponse,
  SkillImportSelection,
  SkillSummary,
  SkillUpdate,
} from "@/types";
import { api } from "../api";

export const skillService = {
  list: (params?: {
    page?: number;
    pageSize?: number;
    category?: string;
    visibility?: string;
    skillType?: string;
    teamUuid?: string;
    search?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    if (params?.category) searchParams.set("category", params.category);
    if (params?.visibility) searchParams.set("visibility", params.visibility);
    if (params?.skillType) searchParams.set("skill_type", params.skillType);
    if (params?.teamUuid) searchParams.set("team_uuid", params.teamUuid);
    if (params?.search) searchParams.set("search", params.search);
    return api.get<PaginatedResponse<SkillSummary>>(`/skills?${searchParams}`);
  },
  get: (skillUuid: string) => api.get<DataResponse<Skill>>(`/skills/${skillUuid}`),
  create: (data: SkillCreate) => api.post<DataResponse<Skill>>("/skills", data),
  update: (skillUuid: string, data: SkillUpdate) => api.put<DataResponse<Skill>>(`/skills/${skillUuid}`, data),
  delete: (skillUuid: string) => api.delete(`/skills/${skillUuid}`),
  /** What deleting this skill would affect (imported siblings + attachment count). */
  deleteImpact: (skillUuid: string) => api.get<DataResponse<SkillDeleteImpact>>(`/skills/${skillUuid}/delete-impact`),
  getCategories: () => api.get<DataResponse<string[]>>("/skills/categories"),
  /** Analyze a bundle (no writes) — returns detected skills/agents for review. */
  analyzeBundle: (file: File) =>
    api.uploadBlob<DataResponse<BundleAnalysis>>("/skills/import/analyze", file, file.name),
  /** Import selected skills/agents from a zipped Agent-Skills bundle (MHS-359). */
  importBundle: (file: File, selection?: SkillImportSelection) =>
    api.uploadBlob<DataResponse<SkillImportResponse>>(
      "/skills/import",
      file,
      file.name,
      "file",
      selection ? { selection: JSON.stringify(selection) } : undefined,
    ),
};
